import React from 'react';
import { Jumbotron as Jumbo, Container } from 'react-bootstrap';
import styled from 'styled-components';
import {Layout} from './components/Layout';
import {Jumbotron} from './components/Jumbotron4';

const Styles=styled.div`

@media only screen and (max-width: 500px) {

.gif{
width:100%;
}
.text{
margin-left:15px;
font-family: 'Open Sans', sans-serif;
font-size: 24px;
margin-top:40px;
margin-right:15px;

}
.title{
font-family: 'Open Sans', sans-serif;
font-size:69px;
color:#0080b9;
margin-top:40px;
padding-top:40px;
text-align:center;
}
.psd2{
width:95%;
margin-top:30px;
margin-bottom:3px;
margin-left:10px
margin-right:10px
border: 2px solid black;
}
.text1{
margin-left:15px;
font-family: 'Open Sans', sans-serif;
font-size: 24px;
margin-top:40px;
margin-right:15px;
}
.email{
width:95%;
margin-top:30px;
margin-bottom:3px;
margin-left:10px;
margin-right:10px;
border: 2px solid black;
}
.text2{
margin-left:15px;
font-family: 'Open Sans', sans-serif;
font-size: 24px;
margin-top:40px;
margin-right:15px;
margin-bottom:150px;
}
.title2{

font-family: 'Open Sans', sans-serif;
font-size:69px;
color:#0080b9;
margin-top:10px;
margin-bottom:20px;
text-align:center;
margin-right:40px;
padding-top:40px;
color:#0080b9;
}
mark.blue{
	color:#0080b9;
	background: none;
	margin-left:-5px;
	font-weight:bold;
}
.design{
width:90%;
margin-top:-50px;
margin-right:30px;
margin-bottom:20px;
margin-left:20px;
border: 2px solid black;
}
.text3{
font-family: 'Open Sans', sans-serif;
margin-top:45px;
margin-bottom:100px;
margin-left:15px;
margin-right:15px;
text-align:left;
font-size:24px;
}
}

@media only screen and (min-width: 501px) {


.gif{
float:left;
width:50%;
border: 2px solid black;
margin-bottom:100px;
margin-right:50px;
margin-left:50px;
}

.text{
margin-left:400px;
font-family: 'Open Sans', sans-serif;
font-size: 24px;
}

.text1{
font-family: 'Open Sans', sans-serif;
margin-right:900px;
margin-left:90px;
margin-top:50px;
margin-bottom:40px;
text-align:left;
font-size:24px;
}

.psd2{
float:right;
width:50%;
margin-top:-90px;
margin-right:40px;
margin-left:30px;
margin-bottom:50px;
border: 2px solid black;

}
.email{
float:left;
width:45%;
margin-top:-150px;
margin-right:100px;
margin-left:50px;
margin-bottom:200px;
border: 2px solid black;

}

.title{
font-family: 'Open Sans', sans-serif;
font-size:69px;
color:#0080b9;
margin-top:300px;
margin-left:90px;
margin-right:900px;

}
.text2{
font-family: 'Open Sans', sans-serif;
margin-top:100px;
text-align:left;
font-size:24px;
margin-right:30px;
margin-left:200px;
margin-bottom:400px;

}
.title2{
font-family: 'Open Sans', sans-serif;
font-size:69px;
color:#0080b9;
margin-top:350px;
text-align:right;
margin-left:675px;
color:#0080b9;
margin-right:300px;
margin-bottom:-40px;
}
mark.blue{
	color:#0080b9;
	background: none;
	margin-left:-5px;
	font-weight:bold;
}
.design{
float:right;
width:50%;
margin-top:-30px;
margin-right:50px;
margin-bottom:200px;
margin-left:60px;
border: 2px solid black;
}
.text3{
font-family: 'Open Sans', sans-serif;
margin-top:550px;
margin-bottom:100px;
margin-left:100px;
text-align:left;
font-size:24px;
}
}

`;
export const CreativeOperations = () => (
<React.Fragment>
	<Styles>
			<Jumbotron />


<img src={require('./assets/cops.jpeg')} alt="Creative Operations Stock Image" Class="gif"/> 
			<body>

	<div class="text">
	<p>In 2017, I was recruited to join Hilton's award-winning internal digital agency now known as Experience Design (XD for short). XD  created the look and feel of <a href="http://www.hilton.com/"target="_blank">Hilton's flagship website</a>, and industry-leading iOS/Android apps.</p>

	<p>My mission was slightly different; I was leading the efforts to replace & revive Hilton's legacy enterprise software.</p>


	<p> My role in XD: I provided digital project management to the ongoing enterprise-facing initiatives (and other ad-hoc requests, like standing up <a href="https://developer.hilton.io/"target="_blank">Hilton's Developer Portal</a>), creating & maintaining agile processes, maintenance of tools for the department (i.e. JIRA, Confluence, etc.) and stakeholder/client relationships.</p>

	
</div>

		  


<div className="title">
	<p> PEP </p>
	</div>
<img src={require('./assets/pep.png')} alt="PEP" Class="psd2" /> 	

		  <div className="text1">
		  	<p> Our very own mobile hotel management system, PEP stands for "Property Engagement Platform".</p>
			
			<p> PEP was built to replace the existing property software. The current system was built in the early 2000s, and was in dire need of a face-lift. With a new, modern app, we created efficiencies and streamlined the hotel's every-day life. This allowed the staff to focus less on fighting technology, and more on creating a unique and outstanding guest experience. </p>
			
			<p>The key KPIs as a part of this project was time to finish tasks and time to train on the technology tools that hotels leveraged. For the hotels leveraging PEP, we reduced time to train by over 70%, and reduce time for operations by 45%.</p>

			
		  </div>
		  
		  <div className="title2">
		<p>Design Sprint</p>
	</div>
		  <img src={require('./assets/designsprint1.jpg')} alt="PEP" Class="email" /> 	



			<div className="text2">
				
			<p>I led & facilitated the very first design sprint for PEP.</p>
			<p><mark class="blue">Methodology:</mark>We had direction from senior leadership to try this without technology - no laptops and no phones. Completely shut off from the outside world, we used Play-Doh, markers, colored pencils, cardboard, glue, and tape.</p>
			
			<p><mark class="blue">Objective:</mark>At the time, housekeeping attendants used paper and pencil to track their assignments. Our objective was to create an MVP mobile app for housekeeping attendants</p>

		</div>
			  <img src={require('./assets/designsprint2.jpg')} alt="PEP" Class="design" /> 

<div className="text3">
			  				<p><mark class="blue">Outcome:</mark> At the end of 3 intense days of workshops, we had 3 MVP paper-style app solutions. This would have normally taken us weeks, if not months had we done this with JIRA tickets.</p>
									<p><mark class="blue">Learnings:</mark> After this first session, design sprints and co-location became a regular exercise built into the project. We were more flexible about using technology, since trying to undo glue and marker proved difficult. </p>
		  
		  
			  </div>
			  
</body>

</Styles>
	</React.Fragment>
	)